import {get, post} from './api';
const getLesson = get('lesson/get');
const saveLesson = post('lesson/save');
const getLessonMembers = get('lesson/members');

export {
    getLesson,
    saveLesson,
    getLessonMembers
}
